export default __webpack_public_path__ + "static/media/r2.9fac6ee4.svg";